module.exports = __webpack_public_path__ + "static/07 - UoE-logo-c7780369ca7c20d09080d1d6dd50e2f2.jpg";